import $ from 'jquery';

export default() => {
    (function (tabi, $) {
        var $dom = {};
        var cacheDom = function cacheDom() {
            $dom.tabPanel = $('.tab-link');
        };

        var selectTab = function selectTab() {
            $('.tab-link').on('click', function (e) {
                e.preventDefault();
                var $this = $(this);
                $('.tab-link').removeClass('font-bold');
                $this.addClass('font-bold');
                var $anchor = $(this).attr('href');
                $('.tab-content').removeClass('active');
                $($anchor).addClass('active');
            });
        };
        tabi.init = function () {
            cacheDom();
            selectTab();
        };
    })(window.tabi = window.tabi || {}, $, undefined);
};